export default "__VITE_ASSET__e14f1c87__"